import { Map, List } from 'immutable';
import timezone from 'tzone';

export function setAuthUser(state, user) {
  if (!user) { // this should never be the case?
    return state.set('authUser', new Map());
  }
  return state.set('authUser', new Map({
    id: user.id,
    name: user.name,
    userLevels: new List(user.user_levels),
  }));
}

export function setAuthUserOrgs(state, orgs) {
  const mapped = orgs.map(org => new Map(org));
  return state.setIn(['authUser', 'organisations'], new List(mapped));
}

export function addLocation(state, location) {
  return state.update('locations', locations => locations.push(new Map(location)));
}

export function setLocations(state, locations) {
  return state.set('locations', new List(locations.map(location => new Map(location))));
}

export function setAccessToken(state, token) {
  return state.set('accessToken', token);
}

// Action helpers

export function validateAccount({
  name, email, phone, password, businessName,
}) {
  if (!name.value || name.value === '') {
    throw new Error('name was empty');
  }
  if (!email.value || email.value === '') {
    throw new Error('email was empty');
  }
  if (!phone.value || phone.value === '') {
    throw new Error('phone was empty');
  }
  if (!password.value || password.value === '') {
    throw new Error('password was empty');
  }
  if (!businessName.value || businessName.value === '') {
    throw new Error('business_name was empty');
  }
}

export function buildAccountData({
  businessName, password, email, phone, name,
  locationCount, staffCount, phonecode,
}) {
  const account = {
    business_name: businessName.value,
    password: password.value,
    email: email.value,
    phone: phone.value.replace(/[^\d+()]/g, ''),
    time_zone: timezone.getLocation(),
    scope: 'me roster timesheet department user cost leave' +
    ' unavailability datastream device settings sms',
    name: name.value,
    signup_type: 'timeclock',
  };

  // append optional
  if (locationCount && locationCount.value) {
    account.locations_count = locationCount.value;
  }
  if (staffCount && staffCount.value) {
    account.staff_count = staffCount.value;
  }
  if (phonecode && phonecode.value) {
    account.phonecode = phonecode.value;
  }

  return account;
}

export function buildLocationRequest(form) {
  return {
    name: form.businessName.value,
  };
}

export function buildDeviceRequest(locationId, form) {
  const {
    businessName: { value: businessName },
  } = form;

  const nickname = `${businessName} Time Clock`;

  return [nickname, { id: locationId, name: businessName }];
}

export function buildIntercom(form, state) {
  const userId = state.getIn(['account', 'authUser', 'id']);
  if (!userId) {
    return {};
  }
  const companyId = state.getIn(['account', 'authUser', 'organisations']).first().get('id');
  const createdAt = (Date.now() / 1000) || 0;

  return {
    userId,
    name: form.name.value,
    email: form.email.value,
    phone: form.phone.value,
    created_at: createdAt,
    company: {
      id: companyId,
      name: form.businessName.value,
      signup_size: form.staffCount.value,
      terms_privacy: true,
      created_at: createdAt,
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/account/lib.js